import React from 'react';
import { CellWrapper } from '@atlassian/jira-admin-pages-issue-types-common/src/ui/index.tsx';

export type Props = {
	hierarchyLevel: number;
};

export const HierarchyLevelCell = ({ hierarchyLevel }: Props) => (
	<CellWrapper>{hierarchyLevel}</CellWrapper>
);
